$(document).on('click','.__ajax-paging button',function(){
    $value = $(this).data('page');
    $(this).closest('form').find('#page').val($value);
    $(this).closest('form').submit();
});